import { createFileRoute, Outlet } from "@tanstack/react-router";
import { progressSentence, StepLinks } from "@/components/onboarding/progress";
import { Page } from "@/components/page/page";
import { describeError } from "@/lib/api";
import { usePathname } from "@/lib/place";
import { useSetupProgress } from "@/lib/progress";

export const Route = createFileRoute("/onboarding")({
  component: OnboardingLayout,
});

/**
 * The setup flow's frame (direction §7: "the steps as a chain of custody"): the sentence under the
 * title says what remains; beside each step, the steps on their chain (held when done, struck
 * when skipped, dashed for the one to do next). The flow's own first page draws that chain as
 * its centre, so it leaves the list beside it out rather than say it twice.
 */
function OnboardingLayout() {
  const progress = useSetupProgress();
  const start = usePathname().replace(/\/+$/, "") === "/onboarding";
  const sentence = !progress
    ? "Progress is saved per organization; there is none yet."
    : progress.isPending
      ? "Loading saved progress."
      : progress.isError
        ? `Saved progress could not be loaded. ${describeError(progress.error).message}`
        : progressSentence(progress.data);
  return (
    <Page title="Setup" documentTitle={false} description={sentence}>
      {start ? (
        <Outlet />
      ) : (
        <div className="grid gap-8 lg:grid-cols-[15rem_minmax(0,1fr)] lg:gap-10">
          <nav
            aria-label="Setup steps"
            className="grid content-start gap-3 lg:sticky lg:top-6 lg:self-start"
          >
            <StepLinks progress={progress} variant="rail" />
          </nav>
          <Outlet />
        </div>
      )}
    </Page>
  );
}
